import { Component, OnInit } from '@angular/core';
import { MasterService,ClassroomService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-candidate',
  templateUrl: './candidate.component.html',
  styleUrls: ['./candidate.component.scss'],
  providers:[MasterService,ClassroomService]
})
export class VtcandidateComponent implements OnInit {

  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
    sections:any=[];
    classes:any=[];
    arrstudent:any=[];
    fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0'};
    arrrepdata:any=[];
    arrper:any=[];
    arrashead:any=[];
    arrcourse:any=[];
    arrpost:any=[];
    arrastype:any=[];
    arrastype1:any=[];
    dropdownList = [];
    selectedItems = [];
    oprtype:any='';
    objcan:any={};
    tabledata: any = {};
    rcremarks='';
    fileToUpload: File = null;
    arrcat:any=[{name:'Board'},{name:'Competitive'}];
    dropdownSettings:IDropdownSettings = {singleSelection: false,
      idField: 'stuid',
      textField: 'stunm',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true};

fData: FormData = new FormData;
    constructor(private http: HttpClient,private aservice:ClassroomService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
  
    ngOnInit(): void {
     
      this.mascourse();
     
      this.getcandidate();
      //this.subjects();
      this.fmodel.attdt=this.mservice.getdatetoday();
      this.fmodel.frtime=this.mservice.getcurenttime();
      this.fmodel.totime=this.mservice.getcurenttime();
      
     
    }
  
    checknumber(ele) {
      if (ele.score < 0 || ele.score==null  )
      {

        ele.score = 0.00;
      }
      else if (ele.score > ele.maxsc) {
        alert('Marks should be less than or equal to maxscore');
        ele.score = ele.accscore1;
  
        console.log("accscore1", ele.accscore1 + " & " + ele.accscore);
      }
      // else {
      //   ele.accscore = parseFloat(ele.accscore).toFixed(0);
      // }
    }
    masclass() {
      this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.fmodel.clid=resultArray[0].clid;
              this.massection();
            //  this.masperiod();
              
             
          },
          error => console.log("Error :: " + error)
          )
    }

    getcandidate() {
      this.aservice.getcanlist()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);

              
              this.arrrepdata = resultArray;
             
              
             
          },
          error => console.log("Error :: " + error)
          )
    }

    massection() {
      this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.sections = resultArray;
              this.fmodel.secid=resultArray[0].scid;
             // this.masasshead();
             this.getstudentsdata();
          },
          error => console.log("Error :: " + error)
          )
    }


    delcan(id) {
      debugger
     if(confirm("Are you sure you want to remove?"))
     {
      this.aservice.delcan(id)
           .subscribe(resultArray => {
              console.log('ret-loop', resultArray);
    //var cbclid=this.fmodel1,cbclid
              alert(resultArray.message);
              if(resultArray.status=='Success')
              {
                
             
              this.selectedItems=[];
        
                this.getcandidate();
                this.getstudentsdata();
              
              }
          }, error =>
              alert('error in connection')
          );
    }
    }
    
 

      onclasschange()
      {
        this.massection();
this.getcandidate();
      }
  
  


      Savercremarks(obj) {
        var objpost={asid:obj.assid,stuid:obj.stuid,rcremarks:this.rcremarks};
        this.aservice.Savercremarks(objpost)
          .subscribe(result => {
            console.log('ret-loop', result);
            alert(result.message);
            //this.Getsel_sp_masassmodel();
          }, error =>
            alert('error in connection')
          );
      }
  
    
      mascourse() {
        this.mservice.mascourse()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrcourse = resultArray;
                this.fmodel.crid=resultArray[0].crid;
                this.masclass();
                //this.fmodel1.crid=resultArray[0].crid;
            },
            error => console.log("Error :: " + error)
            )
      }

      getposts() {
        this.mservice.masposts()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrpost = resultArray;
               
                //this.fmodel1.crid=resultArray[0].crid;
            },
            error => console.log("Error :: " + error)
            )
      }
     
      getstudentsdata() {
        this.aservice.getstudents_bytype(this.fmodel.clid,this.fmodel.secid,this.fmodel.crid,"voting")
            .subscribe(
            resultArray => {
                console.log('bloodgp', resultArray);

                this.arrstudent=resultArray;
                // this.arrstudent =  resultArray.filter(item => this.arrrepdata.find(y => y.stuid !== item.stuid));
                //                     //  jsonArray.filter((item) => filterArray.includes(item.id));
                console.log('bloodgp', this.arrstudent);
            },
            error => console.log("Error :: " + error)
            )
      }

      opensymbol(content,obj)
{
// this.getaccno_series();
this.objcan=obj;
this.modalOptions = {
  backdrop:'static',
  backdropClass:'customBackdrop',
  size:'md'
 }
this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}


openedit(content,obj)
{
// this.getaccno_series();
this.getposts();
this.objcan=obj;
this.modalOptions = {
  backdrop:'static',
  backdropClass:'customBackdrop',
  size:'md'
 }
this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

      upload(files: FileList) {
        debugger;
        this.fileToUpload = files.item(0);
      
       
      }
      
      
     
      fileupload()
      {
      debugger
      
      console.log('file data',JSON.stringify(this.fileToUpload));
      
      this.aservice.uploadsymbol(this.fileToUpload,this.objcan)
      .subscribe(fresult => {
         // console.log('ret',JSON.stringify(fresult));
          alert (fresult.message);
          if(fresult.status=='Success')
      {
      let localmodref=this.modalRef;
      localmodref.close();
      this.getcandidate();
      this.fileToUpload=null;
      // this.dcid=0;
      // this.disuploadbtn=true;
      // this.photo=fresult.updfilepath;
      
      }
          
      }, error => 
      alert('error in connection')
      
      );
      
      
      
      }

      openinfo(content)
 {
  
 
   this.modalOptions = {
     backdrop:'static',
     backdropClass:'customBackdrop',
     size:'lg'
    }
   this.modalRef=this.modalService.open(content,this.modalOptions);
   
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         //this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
         //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
 }
 

 savecbmclassd() {
  debugger
 
  this.aservice.savecandidate(this.fmodel,this.selectedItems)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);
//var cbclid=this.fmodel1,cbclid
          alert(resultArray.message);
          if(resultArray.status=='Success')
          {
            
         
          this.selectedItems=[];
          this.getcandidate();
          this.getstudentsdata();
          }
      }, error =>
          alert('error in connection')
      );
}
        
updcanpost() {
  debugger
 
  this.aservice.updcandidatepost(this.objcan)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);
//var cbclid=this.fmodel1,cbclid
          alert(resultArray.message);
          if(resultArray.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
         
        
          this.getcandidate();
         
          }
      }, error =>
          alert('error in connection')
      );
}
  }
